import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="144"
      height="160"
      viewBox="0 0 144 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H140C142.209 0 144 1.79086 144 4V156C144 158.209 142.209 160 140 160H4C1.79086 160 0 158.209 0 156V4Z"
        fill="white"
      />
      <path
        d="M64.0309 130.6V139H63.0469L58.0069 132.736V139H56.8069V130.6H57.7909L62.8309 136.864V130.6H64.0309ZM69.1012 139.072C68.4692 139.072 67.9012 138.932 67.3972 138.652C66.8932 138.372 66.4972 137.988 66.2092 137.5C65.9292 137.004 65.7892 136.444 65.7892 135.82C65.7892 135.196 65.9292 134.64 66.2092 134.152C66.4972 133.656 66.8932 133.272 67.3972 133C67.9012 132.72 68.4692 132.58 69.1012 132.58C69.7332 132.58 70.2972 132.72 70.7932 133C71.2972 133.272 71.6892 133.656 71.9692 134.152C72.2572 134.64 72.4012 135.196 72.4012 135.82C72.4012 136.444 72.2572 137.004 71.9692 137.5C71.6892 137.988 71.2972 138.372 70.7932 138.652C70.2972 138.932 69.7332 139.072 69.1012 139.072ZM69.1012 138.064C69.5092 138.064 69.8732 137.972 70.1932 137.788C70.5212 137.596 70.7772 137.332 70.9612 136.996C71.1452 136.652 71.2372 136.26 71.2372 135.82C71.2372 135.38 71.1452 134.992 70.9612 134.656C70.7772 134.312 70.5212 134.048 70.1932 133.864C69.8732 133.68 69.5092 133.588 69.1012 133.588C68.6932 133.588 68.3252 133.68 67.9972 133.864C67.6772 134.048 67.4212 134.312 67.2292 134.656C67.0452 134.992 66.9532 135.38 66.9532 135.82C66.9532 136.26 67.0452 136.652 67.2292 136.996C67.4212 137.332 67.6772 137.596 67.9972 137.788C68.3252 137.972 68.6932 138.064 69.1012 138.064ZM77.3903 132.58C78.1983 132.58 78.8383 132.816 79.3103 133.288C79.7903 133.752 80.0303 134.436 80.0303 135.34V139H78.8783V135.472C78.8783 134.856 78.7303 134.392 78.4343 134.08C78.1383 133.768 77.7143 133.612 77.1623 133.612C76.5383 133.612 76.0463 133.796 75.6863 134.164C75.3263 134.524 75.1463 135.044 75.1463 135.724V139H73.9943V132.64H75.0983V133.6C75.3303 133.272 75.6423 133.02 76.0343 132.844C76.4343 132.668 76.8863 132.58 77.3903 132.58ZM87.9455 135.856C87.9455 135.944 87.9375 136.06 87.9215 136.204H82.7615C82.8335 136.764 83.0775 137.216 83.4935 137.56C83.9175 137.896 84.4415 138.064 85.0655 138.064C85.8255 138.064 86.4375 137.808 86.9015 137.296L87.5375 138.04C87.2495 138.376 86.8895 138.632 86.4575 138.808C86.0335 138.984 85.5575 139.072 85.0295 139.072C84.3575 139.072 83.7615 138.936 83.2415 138.664C82.7215 138.384 82.3175 137.996 82.0295 137.5C81.7495 137.004 81.6095 136.444 81.6095 135.82C81.6095 135.204 81.7455 134.648 82.0175 134.152C82.2975 133.656 82.6775 133.272 83.1575 133C83.6455 132.72 84.1935 132.58 84.8015 132.58C85.4095 132.58 85.9495 132.72 86.4215 133C86.9015 133.272 87.2735 133.656 87.5375 134.152C87.8095 134.648 87.9455 135.216 87.9455 135.856ZM84.8015 133.552C84.2495 133.552 83.7855 133.72 83.4095 134.056C83.0415 134.392 82.8255 134.832 82.7615 135.376H86.8415C86.7775 134.84 86.5575 134.404 86.1815 134.068C85.8135 133.724 85.3535 133.552 84.8015 133.552Z"
        fill="#191919"
      />
      <rect
        x="36.25"
        y="31.25"
        width="71.5"
        height="71.5"
        rx="1.75"
        fill="white"
        stroke="#A5A5A5"
        strokeWidth="0.5"
      />
      <g filter="url(#filter0_d)">
        <rect x="38" y="34" width="68" height="68" rx="2" fill="white" />
      </g>
      <rect
        x="8.375"
        y="8.375"
        width="15.25"
        height="15.25"
        rx="0.625"
        stroke="#F1F1F1"
        strokeWidth="0.75"
      />
      <path
        d="M4 0.75H140V-0.75H4V0.75ZM143.25 4V156H144.75V4H143.25ZM140 159.25H4V160.75H140V159.25ZM0.75 156V4H-0.75V156H0.75ZM4 159.25C2.20508 159.25 0.75 157.795 0.75 156H-0.75C-0.75 158.623 1.37665 160.75 4 160.75V159.25ZM143.25 156C143.25 157.795 141.795 159.25 140 159.25V160.75C142.623 160.75 144.75 158.623 144.75 156H143.25ZM140 0.75C141.795 0.75 143.25 2.20508 143.25 4H144.75C144.75 1.37665 142.623 -0.75 140 -0.75V0.75ZM4 -0.75C1.37665 -0.75 -0.75 1.37664 -0.75 4H0.75C0.75 2.20507 2.20507 0.75 4 0.75V-0.75Z"
        fill="#F1F1F1"
      />
    </Svg>
  );
};

export default Icon;
